import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class EncryptionService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public getEncryptedValue(value: string) {
        return this.http.get<string>(this.baseUrl + 'api/Encryption/GetEncryptedValue/?value=' + value);
    }

    public getUnencryptedValue(value: string) {
        return this.http.get<string>(this.baseUrl + 'api/Encryption/GetUnencryptedValue/?value=' + value);
    }

    public getSplitUnencryptedValues(value: string) {
        return this.http.get<string[]>(this.baseUrl + 'api/Encryption/GetSplitUnencryptedValues/?value=' + value);
    }
}